import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { setUserRole } from '../../utils/roleManager';
import { ROLES } from '../../utils/roleManager';

/**
 * Utility Component สำหรับตั้ง Admin Role
 * ใช้สำหรับตั้ง admin role ให้ user ปัจจุบัน (สำหรับ development/testing)
 */
const SetAdminRole = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSetAdmin = async () => {
    if (!currentUser) {
      alert('กรุณาเข้าสู่ระบบก่อน');
      return;
    }

    if (!window.confirm('คุณต้องการตั้ง role เป็น admin จริงหรือไม่?')) {
      return;
    }

    try {
      setLoading(true);
      setSuccess(false);

      const result = await setUserRole(currentUser.uid, ROLES.ADMIN, {
        email: currentUser.email,
        displayName: currentUser.displayName
      });

      if (result) {
        setSuccess(true);
        alert('✅ ตั้ง admin role สำเร็จ! กรุณารีเฟรชหน้าเว็บ (F5)');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        alert('❌ ไม่สามารถตั้ง admin role ได้');
      }
    } catch (error) {
      console.error('Error setting admin role:', error);
      alert('เกิดข้อผิดพลาด: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!currentUser) {
    return (
      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p className="text-yellow-800">กรุณาเข้าสู่ระบบก่อน</p>
      </div>
    );
  }

  const isAdmin = currentUser.role === 'admin' || currentUser.isAdmin === true;

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">🔧 ตั้ง Admin Role</h2>
      
      <div className="mb-4">
        <p className="text-sm text-gray-600 mb-2">ผู้ใช้ปัจจุบัน:</p>
        <p className="font-medium">{currentUser.displayName || currentUser.email}</p>
        <p className="text-xs text-gray-500">UID: {currentUser.uid}</p>
      </div>

      <div className="mb-4">
        <p className="text-sm text-gray-600 mb-2">Role ปัจจุบัน:</p>
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
          isAdmin ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'
        }`}>
          {isAdmin ? '👑 Admin' : currentUser.role || 'ไม่ระบุ'}
        </span>
      </div>

      {isAdmin ? (
        <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-green-800 font-medium">✅ คุณเป็น Admin อยู่แล้ว!</p>
          <p className="text-sm text-green-600 mt-2">
            คุณสามารถเข้าถึง <a href="/admin" className="underline">Admin Panel</a> ได้
          </p>
        </div>
      ) : (
        <div>
          <button
            onClick={handleSetAdmin}
            disabled={loading}
            className="w-full px-4 py-3 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {loading ? '⏳ กำลังตั้งค่า...' : '👑 ตั้ง Admin Role'}
          </button>
          
          {success && (
            <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
              <p className="text-green-800">✅ สำเร็จ! กำลังรีเฟรชหน้าเว็บ...</p>
            </div>
          )}

          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-xs text-blue-800">
              <strong>💡 หมายเหตุ:</strong> หลังจากตั้ง admin role แล้ว ให้รีเฟรชหน้าเว็บ (F5) 
              เพื่อให้ระบบโหลด role ใหม่
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetAdminRole;








